module.exports = __webpack_public_path__ + "img/wangdee_logo_old.1f5ae55d.png";